import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[mhBlurContent]',
    standalone: false
})
export class BlurContentDirective implements OnInit {
  @Input() mhBlurContent = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.applyBlur();
  }

  ngOnChanges(): void {
    this.applyBlur();
  }

  private applyBlur(): void {
    if (this.mhBlurContent) {
      this.renderer.setStyle(this.el.nativeElement, 'filter', 'blur(4px)');
      this.renderer.setStyle(this.el.nativeElement, 'user-select', 'none');
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
    } else {
      this.renderer.removeStyle(this.el.nativeElement, 'filter');
      this.renderer.removeStyle(this.el.nativeElement, 'user-select');
      this.renderer.removeStyle(this.el.nativeElement, 'pointer-events');
    }
  }
}

